var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.displayItems, function (item, i) {
      return _c("dl", { key: i, staticClass: "boss-resumecard-any-list" }, [
        _c("dt", { staticClass: "boss-resumecard-any-head" }, [
          _vm._v("\n      " + _vm._s(item.name) + "\n    "),
        ]),
        _vm._v(" "),
        _c(
          "dd",
          {
            staticClass: "boss-resumecard-any-body",
            attrs: { "data-test": "member-" + item.key },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm._f("parseLabel")(item.data(), item.name)) +
                "\n    "
            ),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }